import React from "react";
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import imageCb from './assets/images/CB.jpg';
import imageSepa from './assets/images/sepa.png';
import imageCheque from './assets/images/cheque.png';
import imageVirement from './assets/images/virement.png';
import { Button } from "react-bootstrap";

const Prix = ({ type, libelle, image }) => (
    <Card style={{ textAlign: "center", width: '10rem' }}>
        <Card.Img variant="top" src={image} style={{ width: "60px", margin: "auto", paddingTop: "10px" }} />
        <Card.Body>
            <Card.Title>{type}<br></br>{libelle}</Card.Title>
        </Card.Body>
    </Card>
);



const InfoTypePaiement = ({ nb_fois_max, handleTarifSelected, adherent }) => {
    const url = localStorage.getItem('url');

    const handleSelPaiement = (paiement, nb) => {
        // alert(paiement + ' ' + nb + ' fois')
        handleTarifSelected(paiement, nb);
    }

    return (
        <>
            <Container>
                <Row>
                    {/* <Col style={{ textAlign: "-webkit-center" }}>
                    <form action={`${url}adhesion/${prix * 100}/${mail}/${code}`} method="POST">
                        <div>
                            <button type="submit" className="btn btn-primary">
                                <Prix tarif={prix} par="" type="Carte bancaire" libelle="" image={imageCb}></Prix>
                            </button>
                        </div>
                    </form>
                </Col> */}

                    <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'CB' && adherent.nb_fois === 1 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('CB', 1)}>
                            <Prix par="" type="Carte Bancaire" libelle="" image={imageCb}></Prix>
                        </Button>
                    </Col>
                    <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'PRELEVEMENT' && adherent.nb_fois === 1 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('PRELEVEMENT', 1)}>
                            <Prix par="" type="Prélèvement SEPA" libelle="" image={imageSepa}></Prix>
                        </Button>
                    </Col>
                    {nb_fois_max >= 3 && <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'PRELEVEMENT' && adherent.nb_fois === 3 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('PRELEVEMENT', 3)}>
                            <Prix par="" type="Prélèvement SEPA" libelle="en 3 fois" image={imageSepa}></Prix>
                        </Button>
                    </Col>}
                    {nb_fois_max === 6 && <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'PRELEVEMENT' && adherent.nb_fois === 6 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('PRELEVEMENT', 6)}>
                            <Prix type="Prélèvement SEPA" libelle="en 6 fois" image={imageSepa}></Prix>
                        </Button>
                    </Col>}

                    <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'VIREMENT' && adherent.nb_fois === 1 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('VIREMENT', 1)}>
                            <Prix type="Virement" libelle="" image={imageVirement}></Prix>
                        </Button>
                    </Col>

                    <Col style={{ textAlign: "-webkit-center" }}>
                        <Button variant={adherent.type === 'CHEQUE' && adherent.nb_fois === 1 ? 'danger' : 'primary'} onClick={() => handleSelPaiement('CHEQUE', 1)}>
                            <Prix type="Cheque" libelle="" image={imageCheque}></Prix>
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default InfoTypePaiement;